import axios from "axios";
import React from "react";
import { connect } from "react-redux";
import { Dimmer, Loader } from "semantic-ui-react";
import SummaryReportHeader from "../../components/SRHHeaders/SummaryReportHeader";
import parse from "url-parse";
import _ from "lodash";

class SignIn extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const params = parse(this.props.location.search, true).query;
    const email = params.email;
    window.location = `${this.props.user.authenticationServerUrl}/send-password-reset?email=${
      email ? email.replace(/\+/g, "%2B") : ""
    }&referrer=https://${window.location.hostname}`;
    return (
      <div>
        <Dimmer active>
          <Loader />
        </Dimmer>
      </div>
    );
  }
}

export default connect(store => {
  return {
    user: store.user,
  };
})(SignIn);



// WEBPACK FOOTER //
// ./src/pages/Activate/index.jsx